import { call, put, takeEvery } from "redux-saga/effects";
import Cookies from 'universal-cookie';
import { appInitAction } from "../../app/appActions";
import appHistory from "../../app/appHistory";
import { failurePut } from "../../app/failurePut";
import { postRequest, putRequest } from "../../app/request";
import RouterPaths from "../../app/routePaths.js";
import {
    confirmEmailFailure,
    confirmEmailSuccess,
    forgotPasswordFailure,
    forgotPasswordSuccess,
    loginFailure,
    logoutFailure,
    logoutSuccess,
    registrationFailure,
    registrationSuccess,
    resetPasswordFailure,
    resetPasswordSuccess,
    updatePasswordFailure,
    updatePasswordSuccess
} from "./authActions";
import {
    CONFIRM_EMAIL_START,
    FORGOT_PASSWORD_START,
    LOGIN_START,
    LOGOUT_START,
    PASSWORD_UPDATE_START,
    REGISTRATION_START,
    RESET_PASSWORD_START
} from "./authConstants";

const cookies = new Cookies();

export function* registrationStartSaga({ payload }) {
    try {
        if (payload.country) {
            cookies.set('country', payload.country, { path: '/', maxAge: 60 * 60 * 24 * 365 });
        }
        const locale = cookies.get('locale');
        yield call(postRequest, '/auth/register', {
            acceptRules: payload.acceptRules,
            email: payload.email,
            phone: payload.phone,
            locale: locale,
            country: payload.country,
            password: payload.password,
        });
        yield put(registrationSuccess());
        yield put(appInitAction());
    } catch (e) {
        yield call(failurePut, e, registrationFailure);
    }
}

export function* loginStartSaga({ payload }) {
    try {
        yield call(postRequest, '/auth/login', payload);

        yield put(appInitAction());
    } catch (e) {
        if (e.response?.status === 401) {
            yield put(loginFailure('Invalid login or password'));
            return;
        }
        if (e.response?.status === 403) {
            yield put(loginFailure('User is inactive'));
            return;
        }
        yield call(failurePut, e, loginFailure);
    }
}


export function* updatePasswordSaga({ payload }) {
    try {
        if (payload.new_password !== payload.new_password_repeat) {
            yield put(updatePasswordFailure('Password mismatch'));
            return;
        }
        yield call(putRequest, '/auth/password', {
            old_password: payload.old_password,
            new_password: payload.new_password
        });
        yield put(updatePasswordSuccess());
    } catch (e) {
        yield call(failurePut, e, updatePasswordFailure);
    }
}

export function* logoutStartSaga() {
    try {
        const data = yield call(postRequest, '/auth/logout');

        yield put(logoutSuccess(data));

        appHistory.push(RouterPaths.main);
    } catch (e) {
        yield call(failurePut, e, logoutFailure);
    }
}

export function* forgotPasswordSaga({ payload }) {
    try {
        yield call(postRequest, '/auth/forgot', payload);
        yield put(forgotPasswordSuccess());
    } catch (e) {
        yield call(failurePut, e, forgotPasswordFailure);
    }
}

export function* resetPasswordSaga({ payload }) {
    try {
        yield call(postRequest, '/auth/reset', payload);
        if (!payload.check) {
            yield put(resetPasswordSuccess());
        }
    } catch (e) {
        if (payload.check) {
            appHistory.push(RouterPaths.login);
        }
        yield call(failurePut, e, resetPasswordFailure);
    }
}

export function* confirmEmailSaga({ payload }) {
    try {
        yield call(postRequest, '/auth/confirm', payload);
        yield put(confirmEmailSuccess());
    } catch (e) {
        yield call(failurePut, e, confirmEmailFailure);
    } finally {
        appHistory.push(RouterPaths.main);
    }
}

export function* authSagas() {
    yield takeEvery(REGISTRATION_START, registrationStartSaga);
    yield takeEvery(LOGIN_START, loginStartSaga);
    yield takeEvery(LOGOUT_START, logoutStartSaga);
    yield takeEvery(PASSWORD_UPDATE_START, updatePasswordSaga);
    yield takeEvery(FORGOT_PASSWORD_START, forgotPasswordSaga);
    yield takeEvery(RESET_PASSWORD_START, resetPasswordSaga);
    yield takeEvery(CONFIRM_EMAIL_START, confirmEmailSaga);
}
